import ToggleStickerSectionButton from "./ToggleStickerSectionButton";
import StickerTray from "./StickerTray";
import UndoRedo from "./Undo";
import { useStickerSectionStore } from "../EditorStore";
import Checkout from "./Checkout";
import Preview from "./Preview";

interface StyleProps {
    showStickersSection: boolean;
}

export default function Footer() {

    const showStickersSection = useStickerSectionStore((state) => state.showStickersSection)
    const isPortrait = useStickerSectionStore((state) => state.isPortrait)

    const footerContainerStyle: React.CSSProperties = {
        position: "absolute",
        bottom: "0",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "35%",
        transition: "height 0.3s ease",
        justifyContent: "end",
        pointerEvents: "none",
        left: "0",
        top: "65dvh",

    };

    const sectionStyle = ({ showStickersSection }: StyleProps): React.CSSProperties => ({
        height: showStickersSection ? "80%" : "0%",
        width: "100%",
        overflow: "hidden",
        transition: "height 0.3s ease",
        display: "flex",
        flexDirection: "row",
        backgroundColor: "rgba(0, 0, 0, 0.5)"
    });

    return (
        <div style={footerContainerStyle}>

            {isPortrait ?
                <div style={{ height: "25%", width: "100%", display: "flex", flexDirection: "row", justifyContent: "end", alignItems: "center", borderBottom: isPortrait ? "2px solid white" : "0px" }}>
                    <ToggleStickerSectionButton />
                    <UndoRedo />
                    <Preview />
                    <Checkout />
                </div> :
                <div style={{ height: "25%", width: "50%", display: "flex", flexDirection: "row", justifyContent: "end", alignItems: "center", borderBottom: isPortrait ? "2px solid white" : "0px" }}>


                    <ToggleStickerSectionButton />
                    <UndoRedo />
                    <Preview />
                    <Checkout />
                </div>
            }



            <div style={sectionStyle({ showStickersSection })}>
                <StickerTray />
            </div>


        </div>
    );
}
